import { TimeInput, Label } from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { TellescopeFormFieldBaseProps } from "../types";
import { FieldDescription } from "../FieldDescription";

export interface TimeFieldProps extends TellescopeFormFieldBaseProps<"Time"> {}

export const TimeField = ({
  title,
  description,
  htmlDescription,
  value,
  onChange,
  className,
  error,
  onBlur,
  touched,
  required,
  autoFocus,
}: TimeFieldProps) => {
  const showError = !!(error && touched);

  return (
    <div className="space-y-1">
      {!!title && <Label required={required}>{title}</Label>}
      <FieldDescription description={description} htmlDescription={htmlDescription} />
      <TimeInput
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={className}
        inputProps={{
          className: cn(showError && "border-destructive"),
          "aria-invalid": showError,
          autoFocus,
        }}
      />
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
